import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Input } from "@/components/ui/input";

export function scorePassword(pw) {
  if (!pw) return 0;
  let s = 0;
  if (pw.length >= 8) s++;
  if (pw.length >= 12) s++;
  if (/[a-z]/.test(pw) && /[A-Z]/.test(pw)) s++;
  if (/\d/.test(pw)) s++;
  if (/[^A-Za-z0-9]/.test(pw)) s++;
  return Math.min(s, 4);
}

export function PasswordInput({ value, onChange, showStrength = false, className = "", ...props }) {
  const { t } = useTranslation();
  const [show, setShow] = useState(false);
  const score = scorePassword(value);
  const labels = ["", t("pwdStrength.weak"), t("pwdStrength.weak"), t("pwdStrength.medium"), t("pwdStrength.strong")];
  const colors = ["bg-border", "bg-red-500", "bg-orange-500", "bg-yellow-500", "bg-emeraude"];
  return (
    <div>
      <div className="relative">
        <Input {...props} type={show ? "text" : "password"} value={value} onChange={onChange} className={`${className} pr-11`} />
        <button type="button" data-testid="toggle-password" aria-label="toggle password" onClick={() => setShow((s) => !s)}
          className="absolute right-3 top-1/2 -translate-y-1/2 text-muted2 hover:text-canard transition-colors">
          {show ? <EyeOff className="w-4 h-4" /> : <Eye className="w-4 h-4" />}
        </button>
      </div>
      {showStrength && value && (
        <div className="mt-1.5" data-testid="password-strength">
          <div className="flex gap-1">
            {[1, 2, 3, 4].map((i) => <div key={i} className={`h-1.5 flex-1 rounded-full transition-colors ${score >= i ? colors[score] : "bg-border"}`} />)}
          </div>
          <p className="text-xs text-muted2 mt-1">{t("pwdStrength.label")}: <span className="font-bold">{labels[score]}</span></p>
        </div>
      )}
    </div>
  );
}
